import { render, staticRenderFns } from "./ActiveMember.vue?vue&type=template&id=4c1c8a04"
import script from "./ActiveMember.vue?vue&type=script&lang=js"
export * from "./ActiveMember.vue?vue&type=script&lang=js"
import style0 from "./ActiveMember.vue?vue&type=style&index=0&id=4c1c8a04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports